import { createLucideIcon } from "lucide-react";

export const ChatHistoryIcon = createLucideIcon("chat-history", [
  [
    "path",
    {
      d: "M12 7v5l4 2",
      key: "1fdv2h",
    },
  ],
  [
    "path",
    {
      d: "M4 3v5h5",
      key: "cyev4e",
    },
  ],
  [
    "path",
    {
      d: "M4.142 7.619a9 9 0 0 1 2.566-2.9 9 9 0 0 1 12.573 12.573 9 9 0 0 1-5.19 3.456A9 9 0 0 1 7.9 20L2 22l2-5.9a9 9 0 0 1-.936-3.1",
      key: "laoy7f",
    },
  ],
]);
